import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=23fc94ba&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=23fc94ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fc94ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23fc94ba')) {
      api.createRecord('23fc94ba', component.options)
    } else {
      api.reload('23fc94ba', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=23fc94ba&scoped=true&", function () {
      api.rerender('23fc94ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8kLsG0xsWzD89/JS/comp/PopupDialog.vue"
export default component.exports